import { ButtonContent } from "./ButtonContent";
import { themeI18n } from '../utils/i18n_helper';

export const PromoTile = ({ promoTile }) => {
  const { height, width, image, link, title, id } = promoTile;

  return (
    <div className={`promo-tile promo-tile-${id} color-secondary`}>
      <style>
        {`
          .promo-tile-${id} {
            --grid-row: span ${height};
            --grid-column: span ${width};

            --grid-row-number: ${height};
            --grid-column-number: ${width};
          }
        `}
      </style>

      <div className="promo-tile__image-wrapper">
        <img src={image} alt={title} className="promo-tile__image-background" />
      </div>

      <div className="promo-tile__content">
        <h2 className="promo-tile__title">{title}</h2>
        <a href={link} className="button">
          <ButtonContent text={themeI18n('collection.fs_promo_tile_cta')} />
        </a>
      </div>
    </div>
  );
};
